import {CanActivateFn} from '@angular/router';

import {getSsoUrl, hasValidSession, shouldBypassAuth} from 'frontend/utils/auth_helpers';

/**
 * Guard that ensures the user is authenticated before activating a route.
 *
 * It prevents unauthenticated users from accessing the application routes.
 * It checks for a valid session token cookie (via `hasValidSession()`).
 * If the token is missing, and auth bypass is not active (e.g., local dev or automated tests),
 * it redirects the user to the SSO login page. It passes the current URL as a
 * `redirect_url` parameter so the user can return after logging in.
 */
export const authGuard: CanActivateFn = (_route, _state) => {
  if (hasValidSession() || shouldBypassAuth()) {
    return true;
  }

  const currentUrl = window.location.href;
  const ssoUrl = getSsoUrl(currentUrl);
  window.location.href = ssoUrl;
  return false;
};
